
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/savings",
      function () {
        return require("private-next-pages/explore/savings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore/savings"])
      });
    }
  